import { faExternalLink } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type Props = {
  enabled: boolean;
  onChange(enabled: boolean): void;
};

export const ViewModelIndividualPermissions: React.FC<Props> = ({ enabled, onChange }: Props) => {
  const handleOnChange = () => {
    onChange(!enabled);
  };

  return (
    <>
      <div className="px-2 pb-2">
        ビューモデルごとにグループに所属するユーザ（ゲストユーザを含む）に権限を設定可能になります。詳しくは
        <a
          href="https://balus-help.levii.co.jp/hc/ja/articles/48249939676825"
          target="_blank"
          rel="noreferrer"
          className="text-blue-700 underline"
        >
          ヘルプページ
          <FontAwesomeIcon icon={faExternalLink} className="pl-1" />
        </a>
        をご参照ください。
        <br />
        設定をオンにすると、ワークスペースの種類によってビューモデルごとの権限設定が行えるようになります。
        <br />
        <ul className="list-disc pl-8">
          <li>
            共有ワークスペースでは、そのワークスペースの管理者によってワークスペースごとに権限設定の可否を変更することができます（デフォルトでは権限設定はオフになっています）。
          </li>
          <li>
            パーソナルワークスペースでは、ビューモデル単位の権限付与が可能になります（ワークスペース単位で無効化することはできません）。
          </li>
        </ul>
        <br />
        設定をオンからオフにする場合は、個別に付与した権限はすべて無効になります。再びオンにすると、すでに設定されている権限が再び有効になります。
      </div>
      <label className="block cursor-pointer p-2 hover:bg-gray-200">
        <input
          type="checkbox"
          className="form-checkbox size-4 cursor-pointer border-brand"
          checked={enabled}
          onChange={handleOnChange}
        />
        <span className="px-2">権限設定を可能にする</span>
      </label>
    </>
  );
};
